import { handleError } from 'config/libraries';
import React, { Fragment, useEffect, useState } from 'react'
import { useForm } from "react-hook-form";
import { ToastContainer, toast } from 'react-toastify';

export const FormList = () => {

    const { register, handleSubmit, formState: { errors } } = useForm();
    const [DataKategori, setDataKategori] = useState();

    useEffect(() => {
        const axios = require('axios');
        axios.get(process.env.REACT_APP_SERVER_BASE_URL + '/kategori-unit-layanan-aduan')
        .then(function (response) {
            setDataKategori(response.data.data);
        })
        .catch(function (error) {
            handleError(error)
        })
        return () => {
            setDataKategori(null)
        };
    }, []);

    function submitUnitLayananAduan(data) {
        const axios = require('axios');
        axios.post(process.env.REACT_APP_SERVER_BASE_URL + '/unit-layanan-aduan', {
            judul_keluhan: data.judul_keluhan,
            nama_lengkap: data.nama_lengkap,
            email_aktif: data.email_aktif,
            nomor_telepon: data.nomor_telepon,
            isi_keluhan: data.isi_keluhan,
            lokasi: data.lokasi,
            status: data.status,
            id_kategori_ula: data.id_kategori_ula,
            gambar_ula: data.gambar_ula,
        }).then(function (response) {
            toast.success('Aduan Berhasil Dikirim', {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }).catch(function (error) {
            if (error.response.data.message != null) {
                if (Array.isArray(error.response.data.message)) {
                    for (const key in error.response.data.message) {
                        toast.error(`${error.response.data.message[key]}`, {
                            position: "bottom-left",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    }
                } else {
                    toast.error(`${error.response.data.message}`, {
                        position: "bottom-left",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }
            } else {
                toast.error('Aduan Tidak Berhasil Dikirim', {
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        });
    }

    return (
        <div className="jl_single_style2">
            <ToastContainer
                position="bottom-left"
                autoClose={5000}
                toastStyle={{ backgroundColor: "#000", color: "#FFF", fontWeight: "bold" }}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <Fragment>
                <form onSubmit={handleSubmit(submitUnitLayananAduan)}>
                    <h1 className='mb-5'>Unit Layanan Aduan</h1>
                    <div className="row">
                        <div className="col-md-12">
                            <h6 className='mb-2'>Informasi Pengirim</h6>
                        </div>
                        <div className="col-md-12 mb-4">
                            <label>Nama Lengkap</label>
                            <input type="text" {...register("nama_lengkap")} className='form-control'></input>
                        </div>
                        <div className="col-md-12 mb-4">
                            <label>Email</label>
                            <input type="email" {...register("email_aktif")} className='form-control'></input>
                        </div>
                        <div className="col-md-12 mb-5">
                            <label>Nomor Telepon</label>
                            <input type="tel" {...register("nomor_telepon")} className='form-control'></input>
                        </div>
                        <div className="col-md-12">
                            <h6 className='mb-2'>Keluhan</h6>
                        </div>
                        <div className="col-md-12 mb-4">
                            <label>Judul</label>
                            <textarea type="text" {...register("judul_keluhan")} rows={2} className='form-control'></textarea>
                        </div>
                        <div className="col-md-12 mb-4">
                            <label>Isi</label>
                            <textarea type="text" {...register("isi_keluhan")} rows={6} className='form-control'></textarea>
                        </div>
                        <div className="col-md-12 mb-4">
                            <label>Lokasi</label>
                            <textarea type="text" {...register("lokasi")} rows={2} className='form-control'></textarea>
                        </div>
                        <div className="col-md-12 mb-4">
                            <label>Kategori</label>
                            <select className='form-control select-costum' {...register("id_kategori_ula")}>
                                {
                                    DataKategori && DataKategori.map((item, index) => {
                                        return (
                                            <option value={item.id}>{item.nama_kategori_ula}</option>
                                        )
                                    })
                                }
                            </select>
                        </div>
                        <div className="col-md-12 mb-5">
                            <label>Gambar</label>
                            <input type="file" {...register("gambar_ula")} className='form-control'></input>
                        </div>
                        <div className="col-md-12">
                            <h6 className='mb-2'>Perizinan</h6>
                        </div>
                        <div className="col-md-12 mb-4">
                            <label>Status Pengajuan</label>
                            <select className='form-control select-costum' {...register("status")}>
                                <option value="true">Publikasi</option>
                                <option value="false">Sembunyikan</option>
                            </select>
                        </div>
                        <div className="col-md-12">
                            <button type='submit' className='btn btn-success'>Ajukan Pengaduan</button>
                        </div>
                    </div>
                </form>
            </Fragment>
        </div>
    )
};